document.addEventListener('productDataLoaded', (event) => {
    console.log("product data loaded...")
    setInitialProductImageState(event.detail.mediaId);

});

function setInitialProductImageState(mediaId) {
    const slickTrack = document.querySelector('.product-single__thumbnails .slick-track');
    const selectedOption = document.querySelector('.product-select__option.selected-label');
    const selectedOptionText = selectedOption.textContent.trim();

    // console.log("Option Text: ", selectedOptionText)
    if (selectedOptionText !== "Select") {
        if (slickTrack) {
            const toBeSelected = slickTrack.querySelector(`a[data-media-id="${mediaId}"]`);
            if (toBeSelected) {
                toBeSelected.click();
            }
        }
    } else {
        setTimeout(() => {
            if (slickTrack) {
                const firstChildDiv = slickTrack.querySelector('div:first-child');

                if (firstChildDiv) {
                    const anchor = firstChildDiv.querySelector('a');

                    if (anchor) {
                        anchor.click();
                    }
                }
            }
        }, 1000)
    }
}